import React from "react";
import BaseApi from "../../../utils/BaseApi";
import {CircularProgress, Modal, ModalClose, ModalDialog} from "@mui/joy";
import Box from "@mui/joy/Box";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from "@mui/joy/Button";
import CommonForm from "../../Common/CommonForm";
import Typography from "@mui/joy/Typography";
import {splitToList} from "../../../utils/misc";


class RouteActionCreateCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            formFields: null,
            success: false,
        };
    }

    async componentDidMount(){
        await this.retrieveFields();
    }

    async retrieveFields(){
        const url = `route_stage_action_create/create_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                formFields: response.data
            }
        );
    }

    async setModalOpenTrue(){
        await this.setState({
            modalOpen: true,
        })
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        formDataObj.stage = this.props.stageId;
        if ('next_stages' in formDataObj) {
            formDataObj.next_stages = splitToList(formDataObj.next_stages, ',')
        }
        const url = `route_stage_action_create/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            await this.setModalOpenFalse();
        }
        return response
    }

    async setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        );
        await this.props.callBack();
    }

    render() {
        if (!this.state.formFields){
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'inline'
                }}
            >
                <Button
                    size={'sm'}
                    color="success"
                    onClick={this.setModalOpenTrue.bind(this)}
                >
                    <AddCircleIcon size={'sm'}/>
                </Button>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                    >
                        <ModalClose
                            onClick={this.setModalOpenFalse.bind(this)}
                        />
                        <Box
                            sx={{
                                overflowY: 'scroll',
                                width: 'calc(80vw)',
                                height: 'calc(80vh)',
                                pr: 2
                            }}
                        >
                            <Typography
                                level={'h2'}
                                sx={{mb: 2}}
                            >
                                Добавление порождения
                            </Typography>
                            <CommonForm
                                fields={this.state.formFields}
                                processForm={this.processForm.bind(this)}
                            />
                        </Box>
                    </ModalDialog>
                </Modal>
            </Box>
        )
    }
}

export default RouteActionCreateCreate
